module.exports = __webpack_public_path__ + "static/media/logo.a025a1ed.png";